import BookingSummary from './booking_summary';

export default BookingSummary;
